import { Button, Skeleton } from '@longy/web-components'
import { createFileRoute, Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { CatalogCard, CatalogPage } from '../../components/catalog/CatalogPage'
import { api } from '../../core/trpc'
import { useLocale } from '../../hooks/useLocale'
import { formatPrice } from '../../utils/formatPrice'

const PATH = '/video-consultations/'

const VideoConsultationsPage = () => {
    const { t } = useTranslation()
    const { getLocalizedValue } = useLocale()

    const { data: services, isPending } = api.service.getPublicVideoConsultations.useQuery({})

    return (
        <CatalogPage
            title={t('frontend.catalog.videoConsultationsTitle')}
            lead={t('frontend.catalog.videoConsultationsLead')}
        >
            {isPending ? (
                <Skeleton className="h-64 w-full" />
            ) : !services?.length ? (
                <p className="text-brand-gray">{t('frontend.catalog.nothingAvailable')}</p>
            ) : (
                <ul className="grid gap-4 sm:grid-cols-2">
                    {services.map((service) => (
                        <li key={service.id} className="flex">
                            <CatalogCard
                                title={getLocalizedValue(service.name)}
                                subtitle={service.expertName}
                                meta={
                                    service.price == null ? undefined : (
                                        <p className="text-sm font-semibold text-primary">
                                            {formatPrice(service.price)}
                                        </p>
                                    )
                                }
                                action={
                                    // Same anchor-ignores-disabled trap as the webinar card. A
                                    // service with no expert cannot prefill the flow, so it gets a
                                    // button that really is inert.
                                    service.expertId ? (
                                        <Button asChild size="sm">
                                            <Link
                                                to="/booking/video-consultation"
                                                search={{ expertId: service.expertId }}
                                            >
                                                {t('frontend.catalog.bookNow')}
                                            </Link>
                                        </Button>
                                    ) : (
                                        <Button disabled size="sm">
                                            {t('frontend.catalog.bookNow')}
                                        </Button>
                                    )
                                }
                            />
                        </li>
                    ))}
                </ul>
            )}
        </CatalogPage>
    )
}

export const Route = createFileRoute(PATH)({
    head: () => ({ meta: [{ title: 'Long-Y - Videokonzultációk' }] }),
    loader: async ({ context }) => {
        await context.apiUtils.service.getPublicVideoConsultations
            .ensureData({})
            .catch(() => undefined)
    },
    component: VideoConsultationsPage,
})
